export default __webpack_public_path__ + "static/media/abuja.2df30e62.jpg";